import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from "../components/shadcn/Checkbox"
import { AlertTriangle, Check, CheckIcon, Loader2 } from 'lucide-react';
import { z } from 'zod';
import axios from 'axios';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  const [isError, setisError] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);
    const [isPending, setisPending] = useState(false);
    const [name, setname] = useState('');
    const [email, setemail] = useState('');
    const [organisation, setorganisation] = useState('');

    async function handleSubmit() { 
        try {
            setisPending(true);
            const { data } = await axios.post(`https://apiregistrationpeppol.qastan.be/peppolregistration/registration`, {
                name: name,
                firm: organisation,
                emailaddress:email
            })
            if(data.errorcode!==0){throw new Error(data.messagge)}
            setisSuccess(true);
        } catch (e) {
            setisError(true);
        } finally {
            setisPending(false);
        }
    }

    function isComplete() {
        try {
            const s = z.object({
                name: z.string().min(1),
                email: z.string().email(),
                organisation: z.string().min(1)
            })
            s.parse({
                name: name,
                email: email,
                organisation: organisation
            });
            return true;
        } catch (e) {
            return false;
        }
    }


  return (
    <>
      <section className="container mx-auto my-20">
        <div className="container px-4 mx-auto">
          <div className="mb-20 text-center section-header">
            <h2 className="text-4xl font-bold text-center md:text-5xl">{t('Contact.Title')}</h2>
            <hr className="block w-12 h-1 mx-auto mt-4 mb-6 border-0 outline-0 bg-legoOrange" />

            <p className="max-w-3xl mx-auto mb-10 text-center lg:text-lg">
              {t('Contact.Subtitle')}
            </p>

            <a target="_blank" className='px-3 py-2 font-medium text-white bg-legoOrange min-h-10' href="https://outlook.office.com/bookwithme/user/455ff4396980438a8540b0001256a510%404e3ed852-201e-495a-a74c-7d4963db4dd6/meetingtype/c845902f-b4c8-48c9-b83c-d4fda5cfae40?anonymous">
              Boek een afspraak
            </a>
          </div>
          <div className="container flex flex-col justify-center w-full gap-4 mx-auto bg-white border-t-4 rounded-lg shadow-2xl md:w-3/4 rounded-t-md border-legoOrange p-7">
            <div>
              <Label>{t('Contact.Naam')}</Label>
              <Input value={name} onChange={(e)=>{setname(e.target.value)}} placeholder={`${t('start-with-peppol.Uw naam')}`} id='name'/>
            </div>
            <div>
              <Label>{t('Contact.Email')}</Label>
              <Input value={email} onChange={(e)=>{setemail(e.target.value)}} placeholder={`${t('start-with-peppol.Uw email')}`} id='email'/>
            </div>
            <div>
              <Label>{t('Contact.Organisatie')}</Label>
              <Input value={organisation} onChange={(e)=>{setorganisation(e.target.value)}} placeholder={`${t('start-with-peppol.Uw organisatie')}`} id='organisation'/>
            </div>
            <Button 
                onClick={()=>{handleSubmit()}} 
                disabled={!isComplete() || isPending || isError || isSuccess}
                className='flex items-center gap-2 !text-white rounded-md'
            >
                {isPending && <><Loader2 className='w-4 h-4 text-white stroke-white animate-spin'/><span className='text-white'>{t('start-with-peppol.Bezig met versturen')}</span></>}
                {isSuccess && <><CheckIcon className='w-4 h-4 text-white stroke-white'/><span className='text-white'>{t('start-with-peppol.Succesvol verstuurd')}</span></>}
                {isError && <><AlertTriangle className='w-4 h-4 text-white stroke-white'/><span className='text-white'>{t('start-with-peppol.Er is een fout opgetreden')}</span></>}
                {(!isPending && !isSuccess && !isError) && <span className='text-white'>{t('start-with-peppol.Verzenden')}</span>}
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
